import { render, staticRenderFns } from "./VContractEditForm.vue?vue&type=template&id=66147c9a&"
import script from "./VContractEditForm.vue?vue&type=script&lang=js&"
export * from "./VContractEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports